import MessagingChannelList from './MessagingChannelList';

export default MessagingChannelList;
